import React, { useState, useEffect } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    Typography,
    ListItemButton,
    Checkbox,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { connect } from 'trim-redux';
import { defaultVariables } from '../../../../../config';
import AppCardLoaderFields from '../../../../components/loaders/AppCardLoaderFields';
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import MakeMenuButton from './MakeMenuButton';

const MenuChooser = ({ shop_id, checkedMenus = [], onCheckedChange }) => {
    const [variables, setVariables] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMenus, setSelectedMenus] = useState(new Set(checkedMenus));
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    useEffect(() => {
        loadData();
    }, [shop_id]);

    useEffect(() => {
        // Pass the selected menu objects to the parent
        onCheckedChange && onCheckedChange([...selectedMenus]);
    }, [selectedMenus]);

    const loadData = async () => {
        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) return;

        try {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            const response = await axios.get(
                `${defaultVariables.url}/menus/get-all/${shop_id}?active=true`,
                config
            );
            setVariables(response.data);
        } catch (error) {
            console.error(error.response);
            enqueueSnackbar(t('errorLoadingData'), { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleToggle = (menu) => {
        setSelectedMenus((prev) => {
            const updated = new Set(prev);
            if ([...updated].find((m) => m.id === menu.id)) {
                updated.delete([...updated].find((m) => m.id === menu.id));
            } else {
                updated.add(menu);
            }
            return updated;
        });
    };

    const handleMenuCreation = (newMenu) => {
        setVariables((prev) => [...prev, newMenu]);
        setSelectedMenus((prev) => {
            const updated = new Set(prev);
            updated.add(newMenu);
            return updated;
        });
    };

    return (
        <>
            {loading ? (
                <AppCardLoaderFields />
            ) : (
                <Grid container spacing={2} justifyContent="center" alignItems="center" className="drag-con">
                    <Grid item size={12} style={{maxHeight:260,overflowY:'auto'}}>
                        {variables.length > 0 ? (
                            <List >
                                {variables.map((item) => (
                                    <ListItem
                                        key={item.id}
                                        style={{border: '1px solid #ddd',borderRadius:7,marginBottom:7}}
                                        secondaryAction={
                                            <Checkbox
                                                color="secondary"
                                                edge="end"
                                                onChange={() => handleToggle(item)}
                                                checked={[...selectedMenus].some((m) => m.id === item.id)}
                                            />
                                        }
                                        disablePadding
                                    >
                                        <ListItemButton onClick={() => handleToggle(item)}>
                                            <ListItemText primary={item.name} />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        ) : (
                            <Typography>{t('noItemsFound')}</Typography>
                        )}
                    </Grid>
                    <Grid item size={12}>
                        <MakeMenuButton
                            variant="text"
                            reload={loadData}
                            shop_id={shop_id}
                            onMenuCreated={handleMenuCreation}
                        />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(MenuChooser);
